export default __webpack_public_path__ + "static/media/googleLogo.45446013.svg";